export default __webpack_public_path__ + "static/media/1.5d2d2e5b.png";